import { BottomSheetModalMethods } from '@gorhom/bottom-sheet/src/types';
import { ChargeCardAction, Maybe } from '@varo/graphql-schema-types';
import { useRouter } from 'expo-router';
import React, { RefObject } from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet, View } from 'react-native';
import { MixedStyleDeclaration } from 'react-native-render-html';
import { HTMLRenderer } from 'shared/components/HTMLRenderer/HTMLRenderer';
import BottomSheet from 'shared/components/vxl/BottomSheet/BottomSheet';
import Button from 'shared/components/vxl/Button/Button';
import BodyBaseText from 'shared/components/vxl/typography/primary/body/BodyBaseText';
import TitleMdText from 'shared/components/vxl/typography/primary/title/TitleMdText';
import theme from 'shared/styles/theme';

export interface BelievePaymentBottomSheetProps {
  bottomSheetRef: RefObject<BottomSheetModalMethods | null> | null;
  id: string;
  data?: Maybe<ChargeCardAction>;
}

const BelievePaymentBottomSheet = ({
  bottomSheetRef,
  id,
  data,
}: BelievePaymentBottomSheetProps) => {
  const router = useRouter();
  const { t: translatedText } = useTranslation('believe', {
    keyPrefix: 'paymentDetails',
  });

  const handleDismiss = () => {
    bottomSheetRef?.current?.dismiss();
  };

  const handlePayCard = () => {
    router.push({
      pathname: '/believe/make-payment',
      params: { id },
    });
    handleDismiss();
  };

  return (
    <BottomSheet ref={bottomSheetRef}>
      <View style={styles.parentContainer} testID="payment-banner-bottom-sheet">
        <View>
          <TitleMdText>{data?.title}</TitleMdText>
        </View>
        <View style={styles.childText}>
          <BodyBaseText>
            <HTMLRenderer
              htmlAsString={data?.message ?? ''}
              tagsStyles={htmlStyles}
            />
          </BodyBaseText>
        </View>
        <View style={styles.buttonContainer}>
          <Button
            label={translatedText('buttons.payCard')}
            type="PRIMARY"
            onPress={() => handlePayCard()}
          />
          <Button
            label={translatedText('buttons.remindMeLater')}
            type="SECONDARY"
            onPress={() => handleDismiss()}
          />
        </View>
      </View>
    </BottomSheet>
  );
};

const styles = StyleSheet.create({
  buttonContainer: {
    gap: theme.spacing.m,
    paddingTop: theme.spacing.m,
  },
  childText: {
    gap: theme.spacing.l,
  },
  parentContainer: {
    gap: theme.spacing.m,
    paddingBottom: theme.spacing.m,
    paddingHorizontal: theme.spacing.m,
  },
});

const htmlStyles: Readonly<Record<string, MixedStyleDeclaration>> =
  StyleSheet.create({
    // eslint-disable-next-line react-native/no-unused-styles
    p: {
      fontSize: 16,
    },
  });

export default BelievePaymentBottomSheet;
